import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Response, Service } from '../models/service';

@Injectable({
  providedIn: 'root'
})

export class ProfessionalTransfersService extends Service<any>  {

  protected override readonly URL: string = `${environment.url}`;

  constructor(private http: HttpClient) { 
    super(http);
  }

  url = `${environment.url}`

  getTotalValueCards(queryParams: string) {
    return this.http.get(`${this.url}/sum-revenue-month-year${queryParams}`) as Observable<any>;
  }

  getChartData(queryParam?: string){
    return this.http.get(`${this.url}/get-graph-revenue-professional${queryParam ? queryParam : ''}`) as Observable<any>;
  }

  getProfessionalListData(queryParams: string){
    return this.http.get(`${this.url}/list-revenue-professional${queryParams}`) as Observable<any>;
  }

  getProfessionalPaymentInfoByID(professionalId: number ,queryParams: string){
    return this.http.get(`${this.url}/sum-revenue-professional${queryParams}`, {
      params: { professional_id : professionalId}
    }) as Observable<any>;
  }

  getProfessionalListByID(professionalId: number ,queryParams: string){
    return this.http.get(`${this.url}/detail-revenue-professional${queryParams}`, {
      params: { professional_id : professionalId}
    }).pipe(
      map((res: any) => new Response(
      res['hydra:member'],
      res['hydra:view'],
      res['hydra:totalItems'],
      this
    ))) as Observable<any>;
  }

  getProfessionalRepost(professionalId: number ,queryParams: string) {
    return this.http.get(`${this.url}/detail/professional/passthrough/by/date${queryParams}`, {
      params: { professional_id : professionalId}
    }).pipe(
      map((res: any) => new Response(
      res['hydra:member'],
      res['hydra:view'],
      res['hydra:totalItems'],
      this
    ))) as Observable<any>;
  }

  getCSVProfessionalListByID(professionalId: number ,queryParams: string){
    const headers = new HttpHeaders({
      'Accept': 'text/csv'
    });

    return this.http.
    get(`${this.url}/detail-revenue-professional${queryParams}`, { 
      headers: headers,
      params:  { csv: true, professional_id : professionalId},
      responseType: 'blob' as 'json' }) as Observable<Blob>;
  }

  // accept: text/csv
}
